import LeadrOrderDetail from './OrderDetail'
import { useSelector } from "react-redux";
import { useEffect, useState } from 'react';

const OrderDetailContainer = () => {
    const {
        orderByIdValue
    }:any = useSelector((state:any)=>({
      orderByIdValue: state.OrderReducer.orderByIdData,
    }))

    const [quantity, setQuantity] = useState(0);

    useEffect(() => {
      let quantityVal = 0;
  
      if (orderByIdValue?.requests?.length > 0) {
        orderByIdValue?.requests.forEach((x: any, _i: any) => {
          quantityVal = quantityVal + x?.quantity;       
        })
        setQuantity(quantityVal)
      }
  
    }, [orderByIdValue]);
  
    const getFormattedValue = (value :any) => {
      let newValue: any;
      if (Number.isInteger(value)) {
        newValue = value?.toLocaleString() + ".00";
      } else {
        newValue = value?.toLocaleString();
      }
      const valueArray = newValue.split(".");
      if (valueArray[1]?.length === 1) {
        return newValue + "0"
      } else {
        return newValue
      }
    }
    
    return <LeadrOrderDetail orderByIdValue={orderByIdValue} getFormattedValue={getFormattedValue} quantity={quantity}/>
}

export default OrderDetailContainer